import { render, staticRenderFns } from "./ToggleBox.vue?vue&type=template&id=334f03a8&scoped=true&"
import script from "./ToggleBox.vue?vue&type=script&lang=ts&"
export * from "./ToggleBox.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleBox.vue?vue&type=style&index=0&id=334f03a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334f03a8",
  null
  
)

export default component.exports